import { render, staticRenderFns } from "./amortize-modal.vue?vue&type=template&id=4229d813&"
import script from "./amortize-modal.ts?vue&type=script&lang=js&"
export * from "./amortize-modal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports